export default class Tag {
  constructor({
    name = '',
    icon = 'label',
    color = '#ffffff',
    pinned = false,
  } = {}) {
    this.name = name;
    this.icon = icon;
    this.color = color;
    this.pinned = pinned;
  }
}
